import { ApolloClient, gql } from '@apollo/client'
import { handleGraphqlError } from './useGraphQLErrorsHandler'

const EDITING_ARTICLE = gql`
  query EditingArticle($id: ID!) {
    editingArticle(id: $id) {
      postID
      id
      title
      content
      categories {
        id
        name
      }
      images {
        id
      }
      coverImageId
      coverImage {
        id
      }
      checkInLocation {
        id
        name
        address
        latitude
        longitude
      }
      ogTitle
      ogDescription
      ogImageId
      ogImage {
        id
      }
      status
      scheduledAt
    }
  }
`

export async function getEditingArticle(apolloClient: ApolloClient<unknown>, id: string) {
  if (id === 'new') return null

  try {
    const response = await apolloClient.query({
      query: EDITING_ARTICLE,
      variables: { id },
    })
    return { data: response.data.editingArticle }
  } catch (error) {
    return { error: handleGraphqlError(error) }
  }
}
